import { useEffect } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Wallet } from "lucide-react";
import { useFetch } from "@/lib/hooks";

export const gbp = (v) => `£${Number(v || 0).toFixed(2)}`;
export const daysLeft = (d) => (d ? Math.max(0, Math.ceil((new Date(d) - Date.now()) / 86400000)) : 0);

export function useWallet() {
  const w = useFetch("/billing/wallet");
  useEffect(() => { const id = setInterval(w.reload, 60000); return () => clearInterval(id); }, [w.reload]);
  return w;
}

export function CreditChip({ wallet }) {
  if (!wallet || wallet.billing_exempt) return null;
  const trial = wallet.status === "trialing" && !wallet.has_subscription;
  return (
    <Link to="/billing" className={`hidden items-center gap-1.5 rounded-full border px-3 py-1 text-xs sm:inline-flex ${wallet.can_spend ? "hover:bg-accent" : "border-destructive/50 text-destructive"}`} data-testid="credit-chip">
      <Wallet className="h-3.5 w-3.5" /><span data-testid="credit-chip-balance">{gbp(wallet.balance_gbp)}</span>
      {trial && <span className="text-muted-foreground">· trial {daysLeft(wallet.trial_ends_at)}d</span>}
    </Link>
  );
}

export function CreditBanner({ wallet }) {
  if (!wallet || wallet.billing_exempt) return null;
  const trialDays = wallet.status === "trialing" && !wallet.has_subscription ? daysLeft(wallet.trial_ends_at) : null;
  const msg = !wallet.can_spend ? wallet.blocked_reason
    : wallet.balance_gbp < 1 ? `Credit is running low (${gbp(wallet.balance_gbp)}) — top up to avoid research stopping`
    : trialDays !== null && trialDays <= 2 ? `Your free trial ends in ${trialDays} day${trialDays === 1 ? "" : "s"} — subscribe to keep researching` : null;
  if (!msg) return null;
  return (
    <div className={`flex items-center gap-2 border-b px-4 py-2 text-sm md:px-8 ${wallet.can_spend ? "border-amber-500/30 bg-amber-500/10 text-amber-800 dark:text-amber-200" : "border-destructive/30 bg-destructive/10 text-destructive"}`} data-testid="credit-banner">
      <AlertTriangle className="h-4 w-4 shrink-0" /><span className="flex-1" data-testid="credit-banner-message">{msg}</span>
      <Link to="/billing" className="font-medium underline" data-testid="credit-banner-link">Go to Billing</Link>
    </div>
  );
}
